import { DropDownModel } from '@app/pages/customer/models/dropdown.model';
import { RecurringType, WeekOfMonth, MyDayOfWeek, DeliveryType } from '@app/@core/enums';

export class CustomerDropDownData {
  public DeliveryTypeDropDown: Array<DropDownModel> = [
    { value: DeliveryType.CallIn, display: 'Call-In' },
    { value: DeliveryType.Recurring, display: 'Recurring' },
  ];

  public RecurringTypeDropDown: Array<DropDownModel> = [
    { value: RecurringType.Weekly, display: 'Weekly' },
    { value: RecurringType.BiWeekly, display: 'Bi-Weekly' },
    { value: RecurringType.Monthly, display: 'Monthly' },
  ];

  public WeekOfMonthDropDown: Array<DropDownModel> = [
    { value: WeekOfMonth.First, display: '1st week' },
    { value: WeekOfMonth.Second, display: '2nd week' },
    { value: WeekOfMonth.Third, display: '3rd week' },
    { value: WeekOfMonth.Fourth, display: '4th week' },
  ];
  public DayOfWeekDropDown = [
    { value: MyDayOfWeek.Monday, name: 'Mon' },
    { value: MyDayOfWeek.Tuesday, name: 'Tue' },
    { value: MyDayOfWeek.Wednesday, name: 'Wed' },
    { value: MyDayOfWeek.Thursday, name: 'Thu' },
    { value: MyDayOfWeek.Friday, name: 'Fri' },
    { value: MyDayOfWeek.Saturday, name: 'Sat' },
    { value: MyDayOfWeek.Sunday, name: 'Sun' },
  ];
}
